module.exports = __webpack_public_path__ + "static/media/cicek1.6bc0fed7.jpg";